import { Reducer } from 'redux';
import {
    CONTACT_DELETE_START,
    CONTACT_DELETE_SUCCESS,
    CONTACT_ERROR,
    CONTACT_CLEAR_ERROR,
    CONTACT_FETCH_START,
    CONTACT_FETCH_SUCCESS,
    CONTACT_SAVE_START,
    CONTACT_SAVE_SUCCESS,
    ContactAction
} from 'actions/contact/ContactActionsTypes';
import { ContactsState, ContactStatus } from './ContactsState';

const initialState: ContactsState = {
    contacts: [],
    status: ContactStatus.Initial,
    loading: false
};

export const contactsReducer: Reducer<ContactsState, ContactAction> = (state = initialState, action) => {
    switch (action.type) {
        case CONTACT_ERROR:
            return {
                ...state,
                loading: false,
                status: ContactStatus.Error,
                error: action.payload.error
            };

        case CONTACT_CLEAR_ERROR:
            return {
                ...state,
                status: ContactStatus.Initial,
                error: undefined
            };

        case CONTACT_FETCH_START:
            return {
                ...state,
                loading: true,
                status: ContactStatus.Fetching,
                error: undefined // Clear previous errors
            };

        case CONTACT_FETCH_SUCCESS:
            return {
                ...state,
                loading: false,
                status: ContactStatus.FetchSuccess,
                // Always replace data for pagination (not infinite scroll)
                contacts: action.payload.contacts
            };

        case CONTACT_SAVE_START:
            return {
                ...state,
                loading: true,
                status: ContactStatus.Saving,
                savedContact: undefined,
                error: undefined // Clear previous errors
            };

        case CONTACT_SAVE_SUCCESS:
            let contacts = [...state.contacts];

            if (contacts.some(c => c.id === action.payload.contact.id)) {
                // Update existing contact
                contacts = contacts.map(c => (c.id === action.payload.contact.id ? { ...action.payload.contact } : c));
            } else {
                // Add new contact
                contacts = [...contacts, { ...action.payload.contact }];
            }

            // Sort by name (lastName, then firstName)
            const sortedContacts = contacts.sort((a, b) => {
                const nameA = `${a.lastName || ''} ${a.firstName || ''}`.trim();
                const nameB = `${b.lastName || ''} ${b.firstName || ''}`.trim();
                return nameA.localeCompare(nameB);
            });

            return {
                ...state,
                loading: false,
                status: ContactStatus.SaveSuccess,
                contacts: sortedContacts,
                savedContact: { ...action.payload.contact }
            };

        case CONTACT_DELETE_START:
            return {
                ...state,
                loading: true,
                status: ContactStatus.Deleting
            };

        case CONTACT_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                status: ContactStatus.DeleteSuccess,
                contacts: state.contacts.filter(c => c.id !== action.payload.contactId)
            };

        default:
            return state;
    }
};

export default contactsReducer;
